// extracted by mini-css-extract-plugin
module.exports = {"mediaQuery":"62rem","background":"#eeece8","cardmaker":"makeCard_cardmaker__C8Mz-","container":"makeCard_container__2BUrx"};